export { default } from './AttacksBasket.jsx';